<template>
  <div>
    <b-modal
      ref="modal"
      title="Reabrir caixa"
      header-class="border-bottom-0"
      size="xs"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            Deseja reabrir este caixa?
          </div>
        </div>
      </div>

      <error-handler :error="error" />

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button
          role="button"
          class="btn btn-success"
          style="margin-left: 5px"
          @click="handleStore()"
        >
          <i class="fas fa-lock-open"></i> Reabrir caixa
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data: () => ({
    account: null,
    shiftId: null,
    error: null,
  }),

  methods: {
    open(account, shiftId) {
      this.account = account;
      this.shiftId = shiftId;
      this.error = null;
      this.$refs.modal.show();
    },

    async handleStore() {
      try {
        await this.$store.dispatch('drawer/postReopenShift', {
          account_id: this.account.id,
          shift_id: this.shiftId,
        });

        await this.$store.dispatch('account/getAccounts');

        this.$refs.modal.hide();
        this.$emit('update');
      } catch (e) {
        this.error = e;
      }
    },
  },
};
</script>
